import firebase from '../../firebase/compat';

// Single client entry point to the saveLead Cloud Function.
// /impactplan is a no-auth page, so its write goes through this callable
// (admin SDK) instead of touching Firestore directly — which lets the
// `Leadlist` rule close to `create: if false` (ADR-022).
// The CF must be called in europe-west1 explicitly; the default client
// points at us-central1 and won't find it.

/**
 * @typedef {object} LeadPayload
 * @property {string} Name - Contact name
 * @property {string} Email - Contact email address
 * @property {string} Compagny - Company name the lead entered
 */

/**
 * @param {LeadPayload} payload - The lead to store
 * @returns {Promise<{success: true}>} CF result data
 */
const callSaveLead = async (payload) => {
    const saveFn = firebase.app().functions('europe-west1').httpsCallable('saveLead');
    const { data } = await saveFn(payload);
    return data;
};

export default callSaveLead;
